<color-widget [formControl]="activeObject.form.get(controlName)">
    <ng-content></ng-content>
</color-widget>